import { combineReducers } from 'redux';
import { AuthReducer } from './AuthReducer';
import { BulletinReducer } from './BulletinReducer';
import { ExploreReducer } from './ExploreReducer';
import { FooterPageReducer } from './FooterPageReducer';
import { ProgramReducer } from './ProgramReducer';
import { ToastReducer } from './ToastReducer';
import { UserDetailsReducer, UserReducer } from './userReducer';
import { FeedBackReducer } from './FeedBackReducer';
import { OverviewReducer } from './OverviewReducer';
import { ReportReducer } from './ReportReducer';
const rootReducer = combineReducers({
  Auth: AuthReducer,
  Toast: ToastReducer,
  User: UserReducer,
  UserDetails: UserDetailsReducer,
  Program: ProgramReducer,
  Bulletin: BulletinReducer,
  Explore: ExploreReducer,
  FooterPage: FooterPageReducer,
  FeedBack: FeedBackReducer,
  Overview: OverviewReducer,
  Report: ReportReducer,
});

export default rootReducer;
